import { getListBrowserStore } from '@ts-private/list-browser';
import { reactiveStore } from '@ts-private/reactive-store';

export const residualValueGridsStore = getListBrowserStore({
  filterDefinitions: [
    {
      name: 'code',
      caption: 'ResidualValueGrid.Code',
      type: 'text'
    },
    {
      name: 'name',
      caption: 'ResidualValueGrid.Name',
      type: 'text'
    },
    {
      name: 'fromDate',
      caption: 'ResidualValueGrid.FromDate',
      type: 'date'
    },
    {
      name: 'toDate',
      caption: 'ResidualValueGrid.ToDate',
      type: 'date'
    },
    {
      name: 'isActive',
      caption: 'ResidualValueGrid.IsActive',
      type: 'boolean'
    },
    {
      name: 'stateId',
      caption: 'ResidualValueGrid.State',
      type: 'select',
      underlyingType: 'number'
    }
  ],
  orderByFields: [
    {
      caption: 'ResidualValueGrid.Name',
      value: 'GridName'
    },
    {
      caption: 'ResidualValueGrid.Code',
      value: 'GridCode'
    },
    {
      caption: 'ResidualValueGrid.FromDate',
      value: 'FromDate'
    },
    {
      caption: 'ResidualValueGrid.ToDate',
      value: 'ToDate'
    }
  ],
  pager: {
    orderBy: 'GridName',
    direction: 'asc'
  }
});

export const stateHistoryResidualValueGridId = reactiveStore(null);
